import React from "react";
import { Grid } from "react-bootstrap";
import ButtonField from "../UI/Button/ButtonField";
let logoValMain = require("../../assets/img/exclamation.png");

const ErrorFallback = ({ error, errorInfo }) => {
  console.warn(error)
  console.warn(errorInfo)
  const styles = {
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh'
    },
    warningIcon:{
      marginBottom: 10,
      width: '50px',
      marginTop: '0px' 
    }
  }
  return (
    <>
      <Grid fluid>
        <div className="text-center" style={styles.container}>
          <img style={styles.warningIcon} src={logoValMain} alt="logo_image" />
          <h3>Oops..! Something went wrong.</h3>
          <ButtonField color="info" submit={() => window.location.reload(true)} BName={"Try Again"}/>
        </div>
      </Grid>
    </>
  )
}

export default ErrorFallback;